"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasketsList = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _ramda = require("ramda");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _config = require("../../../../services/config");
var _selectors = require("../../../Baskets/store/selectors");
var _Basket = _interopRequireDefault(require("../../../Baskets/components/Results/components/Basket"));
var _Offer = _interopRequireDefault(require("../../../Baskets/components/Results/components/Offer"));
var _actions = require("../../../Baskets/store/actions");
var _BasketActions = require("../../../Baskets/components/BasketActions");
var _Wrapper = require("../Wrapper");
var _FillClaimButton = require("./components/FillClaimButton");
var _actions2 = require("./store/actions");
var _styles = _interopRequireDefault(require("./styles"));
var _basketStyles = _interopRequireDefault(require("./basketStyles"));
var _offerStyles = _interopRequireDefault(require("./offerStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var BasketsList = exports.BasketsList = function BasketsList(_ref) {
  var initialBaskets = _ref.baskets;
  var baskets = (0, _reactRedux.useSelector)(_selectors.getBasketsByOrder);
  var _useTranslation = (0, _reactI18next.useTranslation)('WIDGETS'),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  var onRemoveOffer = (0, _react.useCallback)(function (offerID, basketID) {
    dispatch((0, _actions.startRemoveOfferFromBasket)(offerID, basketID));
  }, [dispatch]);
  (0, _react.useEffect)(function () {
    dispatch((0, _actions2.bootstrap)(initialBaskets));
    return function () {
      (0, _config.deleteBasketsList)();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return !(0, _ramda.isEmpty)(baskets) && /*#__PURE__*/_react.default.createElement(_Wrapper.Wrapper, {
    header: t('BASKETS_WIDGET_TITLE')
  }, (0, _ramda.map)(function (_ref2) {
    var id = _ref2.id,
      offersIDs = _ref2.offersIDs,
      discount = _ref2.discount,
      margin = _ref2.margin,
      showPriceWithMargin = _ref2.showPriceWithMargin,
      shortUrl = _ref2.shortUrl;
    return /*#__PURE__*/_react.default.createElement(_Basket.default, {
      basketID: id,
      stylesMap: _basketStyles.default,
      key: id
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.buttons
    }, /*#__PURE__*/_react.default.createElement(_BasketActions.OpenButton, {
      basketID: id
    }), /*#__PURE__*/_react.default.createElement(_BasketActions.CopyButton, {
      content: shortUrl
    }), /*#__PURE__*/_react.default.createElement(_BasketActions.DeleteButton, {
      onDelete: function onDelete() {
        return dispatch((0, _actions.startRemovingBasket)(id));
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.list
    }, (0, _ramda.map)(function (offerID) {
      return /*#__PURE__*/_react.default.createElement(_Offer.default, {
        onRemove: onRemoveOffer,
        isMobile: true,
        basketID: id,
        className: _styles.default.offer,
        stylesMap: _offerStyles.default,
        discount: discount,
        margin: margin,
        key: offerID,
        offerID: offerID,
        showPriceWithMargin: showPriceWithMargin,
        buttons: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FillClaimButton.FillClaimButton, {
          offerID: offerID
        }))
      });
    }, offersIDs)));
  }, baskets));
};
BasketsList.propTypes = {
  baskets: _propTypes.default.arrayOf(_propTypes.default.object).isRequired
};